import http from './http';
import envConfig from '@/config';

const baseURL = envConfig[`VUE_APP_${envConfig.env.toUpperCase()}_BASE_URL`];
// 历史报警记录
export const warningHistoryListApi = (params, config = {}) => http.post('/riskcontrol/warning/history/list', params, { ...config });
// 历史报警记录处理
export const warningHistoryActionApi = (params, config = {}) => http.post('/riskcontrol/warning/history/action', params, { ...config });

// 历史报警记录
export const alarmHistoryGetAlarmHistoryApi = (params, config = {}) => http.post('/riskcontrol/alarmHistory/getAlarmHistory', params, { ...config });

// 历史报警-最近报警信息
export const alarmHistoryLatelyAlarmApi = (params, config = {}) => http.post('/riskcontrol/alarmHistory/latelyAlarm', params, { ...config });

// // 历史报警-导出
// export const alarmHistoryExportApi = (params, config = {}) => (
//   http.get('/riskcontrol/alarmHistory/export', { params, ...config })
// );

// 历史报警-导出

export const alarmHistoryExportApi = (params = {}) => {
  const query = JSON.parse(JSON.stringify(params));
  if (query.pageNum) {
    delete query.pageNum;
  }
  if (query.pageSize) {
    delete query.pageSize;
  }
  const queryStr = Object.keys(query)
    .map((key) => `${key}=${encodeURIComponent(query[key])}`)
    .join('&');
  return `${baseURL}/alarmHistory/export?${queryStr}`;
};

// 历史报警-报警处理
export const alarmHistoryAlarmDealApi = (params, config = {}) => http.post('/riskcontrol/alarmHistory/alarmDeal', params, { ...config });

// 车型选择
export const alarmHistoryVehicleTypeApi = async (params, config = {}) => {
  const resData = await http.get('/riskcontrol/alarmHistory/vehicleType', { params, ...config });
  resData.data = [{ vehicleType: '不限' }, ...resData.data];
  return resData;
};

// 历史报警-查看详情
export const alarmHistoryGetAlarmDetailApi = (params, config = {}) => http.get('/riskcontrol/alarmHistory/getAlarmDetail', { params, ...config });

// 实时报警-实时数据
export const alarmRealTimeRealTimeApi = (params, config = {}) => http.get('/riskcontrol/alarmRealTime/realTime', { params, ...config });

// 实时报警-详情
export const alarmRealTimeRealTimeDetailApi = (params, config = {}) => http.get('/riskcontrol/alarmRealTime/realTimeDetail', { params, ...config });

// 报警类型列表
export const alarmConfigGetAlarmTypeApi = async (params, config = {}) => {
  const resData = await http.get('/riskcontrol/alarmConfig/getAlarmType', { params, ...config });
  resData.data = [{ id: 0, alarmType: '不限' }, ...resData.data];
  return resData;
};

// 报警设置-列表
export const alarmConfigGetAlarmConfigApi = (params, config = {}) => http.post('/riskcontrol/alarmConfig/getAlarmConfig', params, { ...config });

// 报警设置-规则新增
export const alarmConfigAddRulesApi = (params, config = {}) => http.post('/riskcontrol/alarmConfig/addRules', params, { ...config });

// 报警设置-规则更新
export const alarmConfigUpdateRulesApi = (params, config = {}) => http.post('/riskcontrol/alarmConfig/updateRules', params, { ...config });

// 报警设置-规则删除
export const alarmConfigDeleteAlarmConfigApi = (params, config = {}) => http.delete('/riskcontrol/alarmConfig/deleteAlarmConfig', { params, ...config });

// 报警设置-详情
export const alarmConfigAlarmConfigDetailApi = (params, config = {}) => http.get('/riskcontrol/alarmConfig/alarmConfigDetail', { params, ...config });

// 报警设置-待选 车辆
export const alarmConfigSelectedVehicleApi = (params, config = {}) => http.post('/riskcontrol/alarmConfig/selectedVehicle', params, { ...config });

// 报警设置-已选 车辆
export const alarmConfigUserSelectedVehicleApi = (params, config = {}) => http.get('/riskcontrol/alarmConfig/userSelectedVehicle', { params, ...config });

// 报警设置-规则启用/禁用
export const alarmConfigChangeStatesApi = (params, config = {}) => http.get('/riskcontrol/alarmConfig/changeStates', { params, ...config });
